import React, { useState, useMemo } from "react";
import ReactDOM from "react-dom";
import "./WC26TABLE.css";

const WC26TABLE = (props) => {
  const [showPopup, setShowPopup] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [dateFilter, setDateFilter] = useState("");
  const [teamFilter, setTeamFilter] = useState("");

  const data = useMemo(() => {
    try {
      return JSON.parse(props?.item?.text);
    } catch {
      return null;
    }
  }, [props?.item?.text]);

  const matches = data?.matchDetails || [];

  const allTeams = useMemo(() => {
    const teams = new Set();
    matches.forEach((m) => {
      if (m?.c1) teams.add(m.c1);
      if (m?.c2) teams.add(m.c2);
    });
    return [...teams].sort();
  }, [matches]);

  const allDates = useMemo(() => {
    return [...new Set(matches.map((m) => m?.date).filter(Boolean))];
  }, [matches]);

  const filteredMatches = useMemo(() => {
    return matches.filter((m) => {
      const matchDate = !dateFilter || m?.date === dateFilter;
      const matchTeam = !teamFilter || m?.c1 === teamFilter || m?.c2 === teamFilter;
      return matchDate && matchTeam;
    });
  }, [matches, dateFilter, teamFilter]);

  const onClickHandler = () => {
    if (!props.disable) {
      setClicked(true);
      setShowPopup(true);
    }
  };

  const clearFilters = () => {
    setDateFilter("");
    setTeamFilter("");
  };

  if (!data) return null;

  const portalTarget = document.querySelector(".help-chat-box.chatIn-header.help-assistantwrapp.hbc0.maximize");

  return (
    <>
      <button
        className={!props.disable ? "chat-label " : "chat-labelnohover action-tab"}
        style={{
          color: clicked && !showPopup ? "grey" : undefined,
          borderRadius: "44px",
          position: "relative",
          overflow: "visible",
        }}
        onClick={onClickHandler}
      >
        🏏 {props?.item?.buttonText || "View IPL Schedule"}
      </button>

      {showPopup && portalTarget && ReactDOM.createPortal(
        <div className="wc26-overlay">
          <div className="wc26-popup">
            <div className="wc26-header">
              <h3 className="wc26-title">🏏 IPL 2026 Schedule</h3>
              <button className="wc26-close" onClick={() => { setShowPopup(false); setClicked(false); }}>✕</button>
            </div>
            {/* <div className="wc26-match-count">
            Below is the match schedule , To add any of the fav channels to view IPL 2026, Please close this window and continue with the journey
            </div> */}

            <div className="wc26-filters">
              <select
                className="wc26-select"
                value={teamFilter}
                onChange={(e) => setTeamFilter(e.target.value)}
              >
                <option value="">All Teams</option>
                {allTeams.map((team) => (
                  <option key={team} value={team}>{team}</option>
                ))}
              </select>

              <select
                className="wc26-select"
                value={dateFilter}
                onChange={(e) => setDateFilter(e.target.value)}
              >
                <option value="">All Dates</option>
                {allDates.map((date) => (
                  <option key={date} value={date}>{date}</option>
                ))}
              </select>

              {(dateFilter || teamFilter) && (
                <button className="wc26-clear-btn" onClick={clearFilters}>Clear</button>
              )}
            </div>
           
            
            <div className="wc26-table-wrapper">
              {filteredMatches.length > 0 ? (
                filteredMatches.map((match, idx) => (
                  <div className="wc26-match-card" key={idx} style={{ "--i": idx }}>
                    <div className="wc26-match-day">
                      {match?.dayName}, {match?.date}
                    </div>
                    <div className="wc26-match-teams">
                      <span className="wc26-team">{match?.c1}</span>
                      <span className="wc26-vs">VS</span>
                      <span className="wc26-team">{match?.c2}</span>
                    </div>
                    <div className="wc26-match-info">
                      <span>🕖 {match?.match_time} , {match?.venue}</span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="wc26-no-results">No matches found</div>
              )}
            </div>
          </div>
        </div>,
        portalTarget
      )}
    </>
  );
};

export default WC26TABLE;
